// extracted by mini-css-extract-plugin
export default {"subheader":"app-turfs-TurfSelect-TurfSelect-module__CU5gjrMd8kDOswzyM_3l"};